import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BtnLgComponent, BtnComponent } from 'ets-fe-ng-sdk';

export { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

export const BtnModule = [BtnComponent, BtnLgComponent, FontAwesomeModule] as const;
